module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-light-grey full-height flex justify-center items-center border"
  }, [_c('div', {
    attrs: {
      "id": "login-window"
    }
  }, [_c('div', {
    staticClass: "card rounded sh2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 mb2"
  }, [_vm._v("Logg inn")]), _vm._v(" "), (_vm.errors.hasError('login')) ? _c('div', {
    staticClass: "error-flash p2 mb2 rounded"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('login')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.login()
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('username')
    }
  }, [_c('label', [_vm._v("Brukernavn")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), (_vm.errors.hasError('username')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('username')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password')
    },
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Passord")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-block mb3",
    attrs: {
      "disabled": _vm.state.is('authenticating')
    },
    nativeOn: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [(_vm.state.is('authenticating')) ? _c('div', [_vm._v("\n              Logger deg på...\n            ")]) : _c('span', [_vm._v("Logg på")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix mt3"
  }, [_c('div', {
    staticClass: "col col-6 left-align"
  }, [_c('md-checkbox', {
    staticClass: "md-primary m0",
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }, [_vm._v("Husk meg")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-6 right-align"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Glemt passord?")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "center mt2"
  }, [_c('router-link', {
    staticClass: "text-black",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Administrasjonsportal")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "created-by"
    }
  }, [_vm._v("Tjenesten er levert av Frode Fjellberg AS")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p3 bg-light-blue center rounded"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/ui/copy_print_logo.svg",
      "alt": "MyOrder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt2 uppercase fz16 text-dark-blue"
  }, [_vm._v("Bestillingsportal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7d32b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/auth/Login.vue
// module id = 644
// module chunks = 1